import { render, staticRenderFns } from "./mixComponent.vue?vue&type=template&id=585f6815&"
import script from "./mixComponent.vue?vue&type=script&lang=js&"
export * from "./mixComponent.vue?vue&type=script&lang=js&"
import style0 from "./mixComponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports